import styled from 'styled-components';

export const EmojiPickerContainer = styled.div`
  position: absolute;
  ${(props) => (props.position === 'top' ? 'bottom: 100%;' : 'top: 100%;')}
  left: 0;
  margin-top: 8px;
  width: 320px;
  background: ${(props) =>
    props.theme.name === 'dark' ? '#1E293B' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  overflow: hidden;
`;

export const EmojiHeader = styled.div`
  padding: 12px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
`;

export const SearchBox = styled.div`
  position: relative;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(0,0,0,0.05)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
  border-radius: 6px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#0F172A')};
  font-size: 13px;

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#64748B' : '#94A3B8')};
  }

  &:focus {
    outline: none;
    border-color: #fa4616;
    box-shadow: 0 0 0 2px rgba(250, 70, 22, 0.1);
  }
`;

export const EmojiCategory = styled.div`
  display: flex;
  padding: 8px;
  gap: 4px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
    border-radius: 2px;
  }
`;

export const CategoryTab = styled.button`
  padding: 6px 8px;
  background: ${(props) =>
    props.active ? 'rgba(250, 70, 22, 0.1)' : 'transparent'};
  border: 1px solid ${(props) => (props.active ? '#FA4616' : 'transparent')};
  border-radius: 6px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;

  &:hover {
    background: ${(props) =>
      props.active
        ? 'rgba(250, 70, 22, 0.1)'
        : props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(0,0,0,0.05)'};
  }
`;

export const EmojiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
  padding: 12px;
  max-height: 250px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
    border-radius: 4px;
  }
`;

export const EmojiButton = styled.button`
  aspect-ratio: 1;
  padding: 8px;
  background: transparent;
  border: none;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
    transform: scale(1.2);
  }

  &:active {
    transform: scale(1.1);
  }
`;
